<template>
  <div
    class="c-aed-editableDate"
    :class="{
      active: isEditing,
      'c-aed-editableDropdown--textAligned': textAligned
    }"
    :ref="_uid"
  >
    <v-datepicker
      input-class="c-aed-editableDate__input"
      wrapper-class="c-aed-editableDate__wrap"
      calendar-class="c-aed-editableDate__calendar"
      :value="mutableValue"
      @selected="datePickerSelected($event)"
      @opened="handleFocus"
      :use-utc="false"
      format="dd-MM-yyyy"
      :typeable="false"
      :mondayFirst="true"
      :disabledDates="disabledDates"
      :language="datepickerLanguage"
      ref="datepicker"
    >
      ></v-datepicker
    >
    <div
      class="c-aed-editableDate__editable-icon o-button o-button--light-blue o-button--action o-button--square"
      v-if="!isEditing"
    >
      <svg class="o-svg-icon" viewBox="0 0 64 64" type="image/svg+xml">
        <use xlink:href="spritemap.svg#sprite-edit" x="0" y="0"></use>
      </svg>
    </div>
    <button
      class="o-button o-button--action o-button--round"
      v-if="isEditing"
      @click="save"
      @blur="submitIfLeave"
    >
      <svg
        class="o-svg-icon o-button__icon"
        viewBox="0 0 64 64"
        type="image/svg+xml"
      >
        <use xlink:href="spritemap.svg#sprite-check-thinline" x="0" y="0"></use>
      </svg>
    </button>
    <button
      class="o-button o-button--action o-button--round o-button--light"
      v-if="isEditing"
      @click="cancel"
      @blur="submitIfLeave"
    >
      <svg
        class="o-svg-icon o-button__icon"
        viewBox="0 0 64 64"
        type="image/svg+xml"
      >
        <use xlink:href="spritemap.svg#sprite-cross" x="0" y="0"></use>
      </svg>
    </button>
    <div
      v-if="!isValid"
      class="c-aed-editableDate__error-icon o-button o-button--transparent o-button--action o-button--square"
    >
      <svg
        class="o-svg-icon o-svg-icon--error"
        viewBox="0 0 64 64"
        type="image/svg+xml"
      >
        <use xlink:href="spritemap.svg#sprite-warning" x="0" y="0"></use>
      </svg>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { da } from "vuejs-datepicker/dist/locale";
export default {
  name: "c-aed-editableDate",
  data() {
    return {
      isEditing: false,
      mutableValue: "",
      datepickerLanguage: da,
      isValid: true,
      isValidTo: true,
      isValidFrom: true
    };
  },
  props: {
    section: { required: true },
    name: { required: true },
    initialValue: { required: true },
    textAligned: { type: Boolean, default: false },
    disabledDates: { type: Object }
  },
  created() {
    this.mutableValue = new Date(this.initialValue);
    this.validate(this.mutableValue);
  },
  methods: {
    save() {
      this.isEditing = false;
      let payload = {
        api: this.$api,
        id: this.$store.state.aed.all.id,
        section: this.section,
        method: "PATCH",
        data: {
          [this.name]: this.mutableValue
        }
      };
      // payload.data[this.name] = this.mutableValue;

      this.$store.dispatch("aed/setSection", payload);
    },
    cancel() {
      this.isEditing = false;
      this.mutableValue = this.initialValue;
    },
    datePickerSelected(value) {
      this.isEditing = true;
      this.mutableValue = moment(value)
        .format()
        .slice(0, 19);
      this.validate(value);
    },
    validate(value) {
      if (this.disabledDates && this.disabledDates.to) {
        this.isValidTo = !moment(value).isBefore(this.disabledDates.to);
      }
      if (this.disabledDates && this.disabledDates.from) {
        this.isValidFrom = !moment(value).isAfter(this.disabledDates.from);
      }
      this.isValid =
        moment(value).isValid() && this.isValidTo && this.isValidFrom;
    },
    submitIfLeave(event) {
      if (
        this.$refs[this._uid] ===
        (event.relatedTarget && event.relatedTarget.parentElement)
      ) {
        return;
      }
      this.isValid && this.isEditing && this.save();
    },
    onClickOutside(event) {
      event.stopPropagation();

      if (
        this.$refs[this._uid] ===
        event.target.parentElement.closest(".c-aed-editableDate")
      ) {
        return;
      }
      this.isValid && this.isEditing && this.save();
    },
    handleFocus() {
      this.isEditing = true;
      document.addEventListener("mousedown", this.onClickOutside);
    }
  }
};
</script>
<style lang="scss">
.c-aed-editableDate {
  $root: &;
  $input-left-padding: 10px;
  display: flex;
  position: relative;
  width: 100%;

  &--textAligned {
    margin-left: -$input-left-padding;
    width: calc(100% + 10px); //TODO INTERPOLATION does not work
  }

  &__input {
    height: toRem(30px);
    border: none;
    vertical-align: middle;
    border: 1px solid transparent;
    flex: 1 1 100%;
    width: 100%;
    @include setStyles("15", $s-typography-sizes);
    line-height: 17px;
    padding: 0 $input-left-padding;

    + .o-button {
      margin-left: 7px;
    }
  }

  &:not(.active) {
    #{$root}__input {
      text-overflow: ellipsis;
    }
  }

  &:hover {
    #{$root}__input {
      border: 1px solid $s-cp-neutral-600;
    }
    div#{$root}__editable-icon {
      display: block;
      position: absolute;
      top: 0;
      right: 0;
    }
  }

  &__wrap {
    width: 100%;
    > div:first-child {
      width: 100%;
      height: 100%;
      display: flex;
      position: relative;
    }

    + .o-button {
      margin-left: 7px;
    }
  }

  &__calendar {
    .cell {
      &:not(.blank):not(.disabled) {
        &.day,
        &.month,
        &.year {
          &:hover {
            background: $s-cp-sup-light;
            border-color: $s-cp-sup-light;
          }
          &.selected {
            background-color: $s-cp-sup-blue;
            color: $s-cp-neutral-white;

            &:hover {
              background: $s-cp-sup-light;
              color: $s-cp-main;
              border-color: $s-cp-sup-blue;
            }
          }
        }
      }

      &.day-header,
      &.day-header:hover {
        @include setStyles("14", $s-typography-sizes);
        line-height: 40px;
        background-color: $s-cp-neutral-800;
      }
    }
  }

  &.active {
    #{$root}__input {
      border: 1px solid $s-cp-neutral-600;

      &:focus {
        outline: $s-cp-sup-focus auto 1px;
      }
    }
  }

  div#{$root}__editable-icon {
    display: none;
    pointer-events: none;
    z-index: 1;
  }

  div#{$root}__error-icon {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
  }

  .o-button {
    flex: 0 0 auto;
    + .o-button {
      margin-left: 5px;
    }
  }
}
</style>
